/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

export default {
  appName: 'Go',
  clientId: process.env.REACT_APP_OAUTH2_ID,
  scopes: ['email', 'profile', 'openid'],
  features: [],
};
